<template>
<div class="menu__wrapper">
    <div class="menu__wrapper--inner">
        <ul class="menu">
            <grpl-menu v-for="(item, key) in header.acf.menu" :key="'menublock_'+key" :item="item"></grpl-menu>
        </ul>
        <ul class="social">
            <li><a :href="$store.state.social.instagram" target="_blank" rel="noopener"><span>Insta.</span></a></li>
            <li><a :href="$store.state.social.facebook" target="_blank" rel="noopener"><span>FB.</span></a></li>
            <li><a :href="$store.state.social.exposure" target="_blank" rel="noopener"><span>Exposure.</span></a></li>
        </ul>
        <div class="contact--menu">
            <ul>
                <li class="phone"><a href="tel:+44113 487 2741" class="tel">0113 487 2741</a></li>
                <li class="email"><a href="mailto:HELLO@GRAPPLE.CO.UK" class="underline mail" title="hello@grapple.co.uk"><span>hello@grapple.co.uk</span></a><span class="line"></span></li>
            </ul>
        </div>
    </div>
</div>
</template>
<script>
import GrplMenu from './menu-item';
export default {
    components: {
        GrplMenu
    },
    created() {
        let vm = this;
        axios.get('/wp-json/acf/v3/options/general-settings')
            .then( response => { vm.header = response.data; })
            .catch( error => (console.log(error)) );

        $('body').on('click', '.router-link-exact-active', function(){
            if( $('html').hasClass('activemenu') ) {
                Animations.pageReset(true);
            }
        });
        
    },
    data() {
        return {
            header:{
                acf: []
            }
        }
    }
}
</script>